import { createSelector } from 'reselect';
import { currentBoardCanvasElementsSelector, getCurrentVisibleBoardCanvasOrigin } from './currentBoardSelector';
import { getElementId, getXPosition, getYPosition } from '../../../common/elements/utils/elementPropertyUtils';
import getGridSize from '../../utils/grid/gridSizeSelector';

/**
 * Returns the element closest to the top left corner of the current board
 */
export const getTopLeftElement = createSelector(currentBoardCanvasElementsSelector, (elements) =>
    elements?.minBy((element) => getXPosition(element) + getYPosition(element)),
);

export const getTopLeftElementPositionDetails = createSelector(
    getCurrentVisibleBoardCanvasOrigin,
    getGridSize,
    getTopLeftElement,
    (canvasOrigin, gridSize, topLeftElement) => ({
        elementId: getElementId(topLeftElement),
        positionPx: {
            x: ((getXPosition(topLeftElement) || 0) - canvasOrigin.x) * gridSize,
            y: ((getYPosition(topLeftElement) || 0) - canvasOrigin.y) * gridSize,
        },
    }),
);
